/**
 * Created by dale on 09/07/2018.
 */
import * as mediaQueries from './mediaQueries';
(function (browser) {
    browser.boiGlobalConstants = function () {
        return (this.constants = {
            smallBreakpoint: mediaQueries.smallBreakpoint,
            smallBreakpointQuery: mediaQueries.smallBreakpointQuery,
            mediumBreakpointQuery: mediaQueries.mediumBreakpointQuery,
            largeBreakpointQuery: mediaQueries.largeBreakpointQuery,
            isLarge: mediaQueries.isLarge,
            isMedium: mediaQueries.isMedium,
            isSmall: mediaQueries.isSmall,
        });
    };
})(window);
